import { render, staticRenderFns } from "./SInputPreview.vue?vue&type=template&id=4c1736e1&"
import script from "./SInputPreview.vue?vue&type=script&lang=js&"
export * from "./SInputPreview.vue?vue&type=script&lang=js&"
import style0 from "./SInputPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports